var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsHwy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M2 10.333C2 5.73 5.73 2 10.333 2h83.333C98.27 2 102 5.73 102 10.333v83.333c0 4.603-3.73 8.333-8.333 8.333H10.333C5.73 102 2 98.27 2 93.666V10.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M52 3.667c3.927 3.346 9.02 5.365 14.583 5.365 5.563 0 10.656-2.02 14.583-5.366l19.167 19.167c-3.527 5.013-5.598 11.125-5.598 17.72 0 4.745 1.07 9.238 2.985 13.253 1.654 3.47 2.613 7.426 2.613 11.527C100.333 80.06 88.395 92 73.667 92H69.48c-7.056 0-13.355 3.25-17.48 8.333C47.875 95.25 41.576 92 34.52 92h-4.187C15.605 92 3.667 80.06 3.667 65.333c0-4.1.96-8.056 2.613-11.527 1.914-4.015 2.985-8.508 2.985-13.252 0-6.596-2.07-12.708-5.598-17.72L22.833 3.666c3.927 3.346 9.02 5.366 14.583 5.366 5.564 0 10.657-2.02 14.584-5.366z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3.864,
    d: "M52 3.667c3.927 3.346 9.02 5.365 14.583 5.365 5.563 0 10.656-2.02 14.583-5.366l19.167 19.167c-3.527 5.013-5.598 11.125-5.598 17.72 0 4.745 1.07 9.238 2.985 13.253 1.654 3.47 2.613 7.426 2.613 11.527C100.333 80.06 88.395 92 73.667 92H69.48c-7.056 0-13.355 3.25-17.48 8.333C47.875 95.25 41.576 92 34.52 92h-4.187C15.605 92 3.667 80.06 3.667 65.333c0-4.1.96-8.056 2.613-11.527 1.914-4.015 2.985-8.508 2.985-13.252 0-6.596-2.07-12.708-5.598-17.72L22.833 3.666c3.927 3.346 9.02 5.366 14.583 5.366 5.564 0 10.657-2.02 14.584-5.366z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsHwy);
export default __webpack_public_path__ + "static/media/us-hwy.43324df5ad709fd5de4b627a1cb569b9.svg";
export { ForwardRef as ReactComponent };